<template>
    <rkm-list-group>
        <template
            v-for="(atendimento, index) in data.form.historicoAtendimento"
        >
            <rkm-list-group-item
                v-if="limit ? index < limit : true"
                v-bind:key="atendimento.id"
            >
                <rkm-row>
                    <rkm-col
                        align-self="center"
                        class="flex-grow-0"
                    >
                        <rkm-icon
                            :color="atendimento.classificacaoRisco.cor"
                            :title="atendimento.classificacaoRisco.nome"
                            icon="circle"
                            v-rkm-tooltip.hover
                        />
                    </rkm-col>

                    <rkm-col class="flex-grow-1 px-0">
                        <div>
                            <strong>{{ atendimento.unidade.nome }}</strong>
                        </div>
                        <div>
                            {{ atendimento.lotacao.profissional.nome }} - {{ atendimento.lotacao.ocupacao.nome  }}
                        </div>
                        <div>
                            CID10 - {{ atendimento.cid.codigo }} - {{ atendimento.cid.nome }}
                        </div>
                    </rkm-col>

                    <rkm-col
                        align-self="center"
                        class="text-center flex-grow-0"
                    >
                        <rkm-row>
                            <rkm-col
                                class="text-right"
                            >
                                <rkm-button
                                    color="primary"
                                    authorize="list-pronto-atendimento-impressao-faa-eletronica"
                                    @click="imprimir(atendimento)"
                                    small
                                    title="Imprimir FAA eletrônica / Receita"
                                >
                                    <rkm-icon icon="print" />
                                </rkm-button>
                            </rkm-col>
                        </rkm-row>
                        <rkm-row>
                            <rkm-col>
                                <small>{{ atendimento.atendidoEm }}</small>
                            </rkm-col>
                        </rkm-row>
                    </rkm-col>
                </rkm-row>
            </rkm-list-group-item>
        </template>
    </rkm-list-group>
</template>

<script>
// Enums.
import tipoReceita from '@/enums/cadastro/medicamento/tipoReceita'

// Mixins
import {error, file, repository, request} from '@/mixins'

//Vuex
import { mapActions } from 'vuex'

export default {
    data: () => ({
        enums: {
            tipoReceita
        }
    }),
    created() {

        this.repositories = {
            impressao: this.getConectaSusRepository('impressao.prontoAtendimento'),
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        imprimir(atendimento) {

            const promises = [
                this.repositories.impressao.faa.eletronica(atendimento.id)
            ]

            const tiposEspeciais = [
                this.enums.tipoReceita.ESPECIAL,
                this.enums.tipoReceita.ESPECIAL_AMARELA,
                this.enums.tipoReceita.ESPECIAL_AZUL,
            ]

            const hasSomeReceitaEspecial = this.hasSomeReceita(atendimento.receitas, tiposEspeciais)

            if (hasSomeReceitaEspecial) {

                promises.push(
                    this.repositories.impressao.atendimentoMedico.receitaEspecial(atendimento.id)
                )
            }

            const hasSomeReceitaComum = this.hasSomeReceita(atendimento.receitas, [this.enums.tipoReceita.COMUM])

            if (hasSomeReceitaComum) {

                promises.push(
                    this.repositories.impressao.atendimentoMedico.receita(atendimento.id)
                )
            }

            this.setLoading()

            Promise.all(promises)
                .then(responses => {
                    responses.map(response => this.openFile(response.data))
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        hasSomeReceita(receitas, tipo = []) {

            return receitas.some(receita => receita.medicamentos
                .some(m => tipo.includes(m.medicamento.receitaTipoId)))
        }
    },
    mixins: [error, file, repository, request],
    props: {
        data: { type: Object, required: true },
        limit: { type: Number, default: null },
    }
}
</script>